import styled from "styled-components";
import DialogActions from "@mui/material/DialogActions";
import TextView from "../../TextView";
import { colors } from "../../../utils";

export const OTPContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 20px 0;

  input {
    width: 50px;
    height: 50px;
    font-size: 24px;
    text-align: center;
    border: 1px solid #ced4da;
    border-radius: 8px;
    outline: none;
    transition: all 0.3s ease;

    &:focus {
      border-color: #6f42c1;
      box-shadow: 0 0 5px rgba(111, 66, 193, 0.5);
    }
  }
`;

export const StyledDialogActions = styled(DialogActions)`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 10px;
`;

export const Separator = styled.div`
    border: 1px solid #E1E1E1;
`

export const ResendButton = styled.div`
  font-size: 16px;
  line-height: 20px;
  color: #495057;
  font-family: "DM Sans", sans-serif;
  cursor: pointer;
`

export const Error = styled(TextView)`
  color: ${colors.error};
  position: absolute;
  margin-top: -24px;
`;